import saveAs from 'file-saver';

export const exportCSVData = (csvData: string, fileName: string) => {
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8' });
    saveAs(blob, fileName);
};
